import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { SiteState } from '../../shared/models';
import { selectEnvironmentalImpactReport } from '../../store/selectors';

@Component({
  selector: 'app-environmental-impact-quick-view',
  templateUrl: './environmental-impact-quick-view.component.html',
  standalone: false,
})
export class EnvironmentalImpactQuickViewComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<SiteState>>(Store);

  activeIngredientAmount: number = null;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  ngOnInit() {
    this.store
      .pipe(select(selectEnvironmentalImpactReport), takeUntil(this.destroyed$))
      .subscribe(
        (report) =>
          (this.activeIngredientAmount = report?.cropFields
            ? report?.cropFields[0]?.totals?.activeIngredientAmount
            : null),
      );
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
